var DetailPages = function () {

    function initAffix() {

        var header = jQuery('.welcome-header');

        // If the content-header is disabled. Don't do anything here
        if (!header.length) {
            return;
        }

        var topOffset = header.offset().top;

        header.affix({
            offset: {
                top: topOffset
            }
        }).on('affix.bs.affix', function () {
            // triggered on affix active
            if(window.innerWidth < 768){
                jQuery('#content').not('.reduced').css('padding-top',header.height());
                jQuery('.feature-list.--reduced').css('padding-top',header.height());
            }

        }).on('affix-top.bs.affix', function () {
            // triggered on affix not active
            if(window.innerWidth < 768){
                jQuery('#content').not('.reduced').css('padding-top', '');
                jQuery('.feature-list.--reduced').css('padding-top','');
            }
        });

        // wait for image load, then recalculate sub nav.
        jQuery('.welcome-hero').on('load', function(){
            recalculateSubnav();
        })

    }

    function recalculateSubnav() {

        var affixContainer = jQuery('.welcome-header');

        if (affixContainer.data('bs.affix')) {
            affixContainer.data('bs.affix').options.offset.top = affixContainer.offset().top;
        }

    }

    jQuery(window).resize(function () {

        recalculateSubnav();

    });

    function initAjax() {

        initAffix();

    }

    // init

    function init() {

        initAffix();

    }

    // init();

    // public methods

    return {

        initAffix: initAffix,
        initAjax: initAjax

    }

}();



